import { useAuth } from '../hooks/useAuth';
import { useSafeRedirect } from './useSafeRedirect';
import PageLoader from '../components/loaders/PageLoader';

export default function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  useSafeRedirect('/dashboard', !loading && isAuthenticated);

  if (loading) {
    return <PageLoader />;
  }

  if (isAuthenticated) {
    return null;
  }

  return children;
}
